import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "職員名",
    value: "resultCd",
    keyword: "staffNameKanji",
    type: "text",
    text: "",
  },
  {
    title: "性別",
    keyword: "sex",
    type: "text",
    text: "",
  },
  {
    title: "職種",
    keyword: "jobName",
    type: "text",
    text: "",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
    text: "",
  },
  {
    title: "加入日",
    keyword: "firstJoinDate",
    type: "text",
    text: "",
  },
  {
    title: `在籍期間`,
    keyword: "periodOfEnrollment",
    type: "text",
    text: "",
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
    text: "",
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    type: "text",
    text: "",
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "text",
    text: "",
  },
  {
    lineTitle: "",
    keyword: "title1",
    type: "lineTitle",
  },
  {
    title: "合計",
    keyword: "sum",
    type: "text",
    text: "",
  },
  {
    title: "退職届提出日",
    keyword: "applyDate",
    type: "text",
    text: "",
  },
  {
    title: "支給額",
    keyword: "paymentAmt",
    type: "text",
    text: "",
  },
  {
    title: "送金予定日",
    keyword: "remitDueDate",
    type: "text",
    text: "",
  },
  {
    lineTitle: "",
    keyword: "title2",
    type: "lineTitle",
  },
  {
    title: "ならない月",
    keyword: "unrecognizedMonthList",
    type: "nodeInLine",
  },
  {
    title: "テーブル",
    keyword: "childcareLeaveList",
    type: "node",
    text: "",
  },
  {
    lineTitle: "",
    keyword: "title3",
    type: "lineTitle",
  },
  {
    title: "異動履歴",
    keyword: "transferHistoryList",
    type: "multipleLinesWithBorder",
  },
];

//名前後で修正
const SubmitTableList: ITkFakeTableLineProps[] = [
  {
    title: "請求者の氏名",
    keyword: "businessOwnerClass",
    type: "label",
    requiredIcon: true,
  },
  {
    title: "請求者のメールアドレス",
    keyword: "email",
    type: "mail",
    requiredIcon: true,
  },
  {
    title: "請求者のメールアドレス（確認用）",
    keyword: "emailConfirm",
    type: "mail",
    requiredIcon: true,
  },
  {
    title: "通知書送付先住所（郵便番号）",
    keyword: "deliveryZipcode",
    type: "addressSearch",
    inputProps: { maxLength: 7 },
    requiredIcon: true,
  },
  {
    title: "通知書送付先住所",
    keyword: "deliveryAddress",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: true,
  },
];

const infoHeadTitleList = [
  {
    headTitle: "出産日",
  },

  {
    headTitle: "育児休業開始日",
  },

  {
    headTitle: "育児休業終了日",
  },

  {
    headTitle: "パパママ育休プラス",
  },

  {
    headTitle: "半年延長の理由",
  },

  {
    headTitle: "産後パパ育休",
  },
];

const symbolHeadList: any = [
  { headTitle: "帳票名", align: "left" },
  { headTitle: "記号番号", align: "left" },
  { headTitle: "決裁日", align: "left" },
];

const monthMapping = {
  Apr: "4",
  May: "5",
  Jun: "6",
  Jul: "7",
  Aug: "8",
  Sep: "9",
  Oct: "10",
  Nov: "11",
  Dec: "12",
  Jan: "1",
  Feb: "2",
  Mar: "3",
} as any;

const schema = {
  remark: {
    minLength: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};
const demanderSchema = {
  businessOwnerClass: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 47,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
  email: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "86"),
    },
  },
  emailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "86"),
    },
    validate: (value: any, formValues: any) => {
      if (formValues.email !== formValues.emailConfirm) {
        return TkPropertyMessageGet("TKMSG_SCR0001E");
      }
    },
  },
  deliveryZipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  deliveryAddress: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };
      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : "",
        city: !data?.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.city.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : // eslint-disable-next-line no-control-regex
          !data.city.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.address.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "86")
          : // eslint-disable-next-line no-control-regex
          !data.address.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
      };

      if (
        error.prefectures !== "" ||
        error.city !== "" ||
        error.address !== ""
      ) {
        return JSON.stringify(error);
      }
    },
  },
};

export {
  schema,
  fakeTableList,
  SubmitTableList,
  infoHeadTitleList,
  demanderSchema,
  symbolHeadList,
  monthMapping,
};
